import { cn } from '@theprintbar/shared';
import { Collapse, Expand } from '@theprintbar/ui';
import { useState } from 'react';
import { CategoryList } from './CategoryList';
import { FilterListProps, ProductFilterList } from './ProductFilter';

interface DesktopFilterProps extends Omit<FilterListProps, 'expandAll'> {
	crew?: boolean;
	store?: any;
}

export function DesktopFilter(data: DesktopFilterProps) {
	const [expandAll, setExpandAll] = useState(false);

	return (
		<div className={cn('hidden flex-col w-[337px] pr-8 lg:flex', !data.crew && !data.store && 'pl-8')}>
			<CategoryList {...data} />
			<div className="flex justify-between items-center h-16">
				<h5 className="font-display font-light text-xl">Filters</h5>
				<button onClick={() => setExpandAll(!expandAll)} className="flex items-center gap-2 text-sm">
					{expandAll ? 'Collapse All' : 'Expand All'}
					{expandAll ? <Collapse className="w-3 h-3" /> : <Expand className="w-3 h-3" />}
				</button>
			</div>
			<ProductFilterList expandAll={expandAll} {...data} />
		</div>
	);
}
